/**
 * WalterGO Error/Friction Umami-Tracker
 * Spec: analytics/tracking-spec.md §3.7
 *
 * EVENTS:
 *   error.404                  attempted_path  (gefeuert direkt aus sections/main-404.liquid)
 *   error.form_validation      form_id  (oder Form-Identifier)
 *   error.add_to_cart_failed   error_code
 *   error.fpt_load_failed      —
 *
 * 404 wird inline aus main-404.liquid gefeuert (vor diesem Skript verfügbar dank Polling).
 */
(function () {
  'use strict';

  function track(name, data) {
    if (typeof window.wgTrack === 'function') {
      window.wgTrack(name, data);
    }
  }

  // -- Form-Validation-Fehler (HTML5 invalid event, capture phase)
  document.addEventListener('invalid', function (e) {
    var field = e.target;
    if (!field || !field.form) return;
    var form = field.form;
    var formId = form.id || form.getAttribute('name') || 'unknown';
    // Dedupe: ein Event pro Form-Submit-Versuch (nicht pro Field)
    if (form.__wgInvalidFired) return;
    form.__wgInvalidFired = true;
    setTimeout(function () { form.__wgInvalidFired = false; }, 1000);
    track('error.form_validation', { form_id: formId.slice(0, 50) });
  }, true);

  // -- Cart-Error via PUB_SUB_EVENTS.cartError
  // WICHTIG: PUB_SUB_EVENTS ist const → script-scoped, NICHT auf window.
  // Direkter typeof-Check (kein ReferenceError bei undefined).
  function subscribeCartError() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') {
      setTimeout(subscribeCartError, 200);
      return;
    }
    subscribe(PUB_SUB_EVENTS.cartError, function (payload) {
      var code = 'unknown';
      if (payload) {
        if (typeof payload.errors === 'string') code = payload.errors.slice(0, 50);
        else if (payload.errors && payload.errors[0]) code = String(payload.errors[0]).slice(0, 50);
        else if (payload.message) code = String(payload.message).slice(0, 50);
      }
      track('error.add_to_cart_failed', { error_code: code });
    });
  }
  subscribeCartError();

  // -- FPT-Load-Timeout: Wenn auf einer Produktseite nach 10s kein
  //    [data-widget="fpt-button"] existiert, war FPT-Widget nicht erreichbar
  function watchFptLoad() {
    if (!/\/products\//.test(window.location.pathname)) return;
    setTimeout(function () {
      var fpt = document.querySelector('[data-widget="fpt-button"]');
      if (!fpt) {
        track('error.fpt_load_failed');
      }
    }, 10000);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchFptLoad);
  } else {
    watchFptLoad();
  }
})();
